/**
 * Auto-generated payment-product names. The admin never types a name in the
 * inline flow, but the name IS user-visible: the API pushes it to Stripe as
 * "<Org> — <name>", which renders on Stripe-hosted checkout, the embedded
 * checkout iframe, and Stripe receipts — so it must stay human-readable.
 * Collisions get " (2)", " (3)", … (case-insensitive) because Stripe-side
 * product names are how admins tell two fees apart.
 */
export default function autoProductName(base: string, existingNames: Array<string | undefined | null>): string {
  const taken = new Set(
    existingNames
      .filter((n): n is string => typeof n === 'string')
      .map((n) => n.trim().toLowerCase()),
  );
  const cleanBase = base.trim();
  if (!taken.has(cleanBase.toLowerCase())) return cleanBase;
  for (let i = 2; ; i += 1) {
    const candidate = `${cleanBase} (${i})`;
    if (!taken.has(candidate.toLowerCase())) return candidate;
  }
}
